import { observer } from "mobx-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { userStore } from "store/userStore";

type AuthGuardProps = {
  children: ReactNode;
};

const AuthGuard = observer(({ children }: AuthGuardProps) => {
  if (!userStore.token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
});

export default AuthGuard;
